import React from "react";
import "../assets/css/visionmissioncard.css";
// VisionMissionCard - paste into the same file as OverviewPanel (above or below it)
const VisionMissionCard = ({
  title = "Title",
  body = "",
  accent = "blue",
  icon = "vision",
}) => {
  const icons = {
    vision: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden
        focusable="false"
      >
        <path
          d="M12 5C7 5 3.3 8.1 2 12c1.3 3.9 5 7 10 7s8.7-3.1 10-7c-1.3-3.9-5-7-10-7z"
          fill="currentColor"
          opacity="0.14"
        />
        <path
          d="M12 9.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z"
          fill="currentColor"
        />
      </svg>
    ),
    mission: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden
        focusable="false"
      >
        <path
          d="M12 2l3 7h7l-5.6 4.1L20 22l-8-5-8 5 1.6-8.9L0 9h7l3-7z"
          fill="currentColor"
          opacity="0.12"
        />
        <path
          d="M12 6l1.8 4.2L18 11l-3.6 2.6L13.5 18 12 14l-1.5 4-0.9-4.4L6 11l4.2-.8L12 6z"
          fill="currentColor"
        />
      </svg>
    ),
  };

  return (
    <article className={`progov-vm-card progov-vm-card--${accent}`}>
      <div className="progov-vm-left">
        <div className="progov-vm-icon">
          {icon === "mission" ? icons.mission : icons.vision}
        </div>
      </div>
      <div className="progov-vm-right">
        <div className="progov-vm-heading">{title}</div>
        <div className="progov-vm-copy">
          {String(body)
            .split("\n")
            .map((line, i) => (
              <p key={i}>{line}</p>
            ))}
        </div>
      </div>
    </article>
  );
};

export default VisionMissionCard;
